<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (moiModel && moiPermissions) {
    <div class="detail-page-action-bar">
        <button
            class="btn btn-cerrix"
            (click)="save()"
            [disabled]="moiPermissions.canOnlyReadMoi || hideSaveButton"
        >
            <i class="fas fa-save"></i>
            <span data-uiid="moi-save" class="d-none d-lg-inline">{{ 'detail.saveMoiBtn' | t }}</span>
        </button>

        @if (moiModel.Id > 0) {
            <span class="date-edited">
                Last save: {{ moiModel.DateUpdated | dateTimeFormat }}
            </span>

            <div class="workflow-area">
                <span class="workflow-description">
                    {{ 'detail.workflowStatusLabel' | t }}
                    <b>{{ moiStatusDescription }}</b>
                </span>
                @if (!workflowDisabled) {
                    <span>
                        @if (moiPermissions.canConfirm) {
                            <button
                                data-uiid="moi-confirm-button"
                                class="btn btn-success"
                                type="button"
                                (click)="nextStatus(true)"
                                [matTooltip]="'detail.workflowTooltipConfirm' | t"
                            >
                                {{ 'detail.workflowBtnConfirm' | t }}
                            </button>
                            <button
                                data-uiid="moi-decline-button"
                                class="btn btn-danger"
                                type="button"
                                (click)="nextStatus(false)"
                                [matTooltip]="'detail.workflowTooltipDecline' | t"
                            >
                                {{ 'detail.workflowBtnDecline' | t }}
                            </button>
                        }
                        @if (moiPermissions.canResubmit) {
                            <button
                                data-uiid="moi-resubmit-button"
                                class="btn btn-success"
                                type="button"
                                (click)="nextStatus(true)"
                                [matTooltip]="'detail.workflowTooltipResubmit' | t"
                            >
                                {{ 'detail.workflowBtnResubmit' | t }}
                            </button>
                        }
                        @if (moiPermissions.canSetReadyForAcceptance) {
                            <button
                                data-uiid="moi-ready-for-acceptance-button"
                                class="btn btn-success"
                                type="button"
                                (click)="nextStatus(true)"
                                [matTooltip]="'detail.workflowTooltipReadyForAcceptance' | t"
                            >
                                {{ 'detail.workflowBtnReadyForAcceptance' | t }}
                            </button>
                        }

                        @if (moiPermissions.canAccept) {
                            <button
                                data-uiid="moi-accept-button"
                                class="btn btn-success"
                                type="button"
                                (click)="nextStatus(true)"
                                [matTooltip]="'detail.workflowTooltipAccept' | t"
                            >
                                {{ 'detail.workflowBtnAccept' | t }}
                            </button>
                            <button
                                data-uiid="moi-reject-button"
                                class="btn btn-danger"
                                type="button"
                                (click)="nextStatus(false)"
                                [matTooltip]="'detail.workflowTooltipReject' | t"
                            >
                                {{ 'detail.workflowBtnReject' | t }}
                            </button>
                        }

                        @if (moiPermissions.canClose) {
                            <button
                                data-uiid="moi-close-button"
                                class="btn btn-warning"
                                type="button"
                                (click)="closeMoi()"
                                [matTooltip]="'detail.workflowTooltipCloseMoi' | t"
                            >
                                {{ 'detail.workflowBtnCloseMoi' | t }}
                            </button>
                        }
                        @if (moiPermissions.canReopen) {
                            <button
                                data-uiid="moi-reopen-button"
                                class="btn btn-dark"
                                type="button"
                                (click)="nextStatus(true)"
                                [matTooltip]="'detail.workflowTooltipReopen' | t"
                            >
                                {{ 'detail.workflowBtnReopen' | t }}
                            </button>
                        }
                    </span>
                }
            </div>
        }
    </div>

    <div
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
        class="moi-screen-system"
    >
        <div
            class="moi-screens"
            [attr.name]="'detail.moiTypes.' + moiTypeKey | t"
            menuicon="fas fa-tasks"
            menusystemsubmenu
        >
            @if (sd) {
                <div [attr.name]="'detail.menuDetails' | t" menuItemId="menuItemDetails" menuicon="fas fa-info-circle" menusystemitem>
                    @if (moiModel.Id > 0) {
                        <div class="detail-page-summary">
                            <div class="row">
                                <div class="col-6">
                                    <input type="hidden" data-uiid="moi-id" [value]="moiModel.Id" readonly />
                                    <input type="hidden" data-uiid="moi-guid" [value]="moiModel.Guid" readonly />
                                    <input type="hidden" data-uiid="moi-identifier" [value]="moiModel.Identifier" readonly />

                                    
                                    <div class="property"><b>{{ 'detail.summaryId' | t }}</b>
                                        <span data-uiid="moi-identifier-label">{{ moiModel.Identifier }}</span>
                                    </div>
                                    <div class="property">
                                        <b>{{ 'detail.summaryName' | t }}</b>
                                        <span data-uiid="moi-name-label">{{ moiModel.Name }}</span>
                                    </div>
                                    <div class="property">
                                        <b>{{ 'detail.summaryRequester' | t }}</b> {{ moiModel.Requester }}
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="property">
                                        <b>{{ 'detail.summaryDueDate' | t }}</b> {{ moiModel.DueDate | dateFormat }}
                                    </div>
                                    <div class="property">
                                        <b>{{ 'detail.summaryInitialDueDate' | t }}</b>
                                        {{ moiModel.InitialDueDate | dateFormat }}
                                    </div>
                                    <div class="property">
                                        <b>{{ 'detail.summaryDateCreated' | t }}</b> {{ moiModel.DateCreated | dateFormat }}
                                    </div>
                                    <div class="property">
                                        <b>{{ 'detail.summaryDateStatusChanged' | t }}</b>
                                        {{ moiModel.DateStatusChanged | dateFormat }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <moi-comments
                            [moiGuid]="moiModel.Guid"
                            [permissions]="moiPermissions.commentPermissions"
                            #comments
                        >
                        </moi-comments>
                    }

                    <moi-detail-main
                        [moiModel]="moiModel"
                        [sd]="sd"
                        [permissions]="moiPermissions"
                        [parentSummary]="parentSummary"
                        [parentForm]="parentForm"
                    >
                    </moi-detail-main>
                </div>
            }
            <div [attr.name]="'detail.menuLinks' | t" menuicon="fas fa-link" menusystemsubmenu>
                @if (showLinkedRisksAndControls) {
                    <div [attr.name]="'detail.menuRisks' | t" menuItemId="menuItemRisks" menuicon="fas fa-exclamation-triangle" menusystemitem>
                        <moi-risks
                            [model]="moiModel"
                            [disabled]="!moiPermissions.canLinkControls"
                            (changed)="linkedRiskControlsChanged()"
                            #moiRisksComponent
                        >
                        </moi-risks>
                    </div>
                    <div [attr.name]="'detail.menuControls' | t" menuItemId="menuItemControls" menuicon="fas fa-shield-alt" menusystemitem>
                        <moi-controls
                            [model]="moiModel"
                            [disabled]="!moiPermissions.canLinkControls"
                            [moiPermissions]="moiPermissions"
                            (changed)="linkedRiskControlsChanged()"
                            #moiControlsComponent
                        >
                        </moi-controls>
                    </div>
                }
                @if (showLinkedFindings) {
                    <div [attr.name]="'detail.menuAuditFindings' | t" menuItemId="menuItemAuditFindings" menuicon="fas fa-radar" menusystemitem>
                        <moi-findings
                            [model]="moiModel"
                            [disabled]="!moiPermissions.canLinkFindings"
                            (changed)="linkedRiskControlsChanged()"
                            #moiFindingsComponent
                        >
                        </moi-findings>
                    </div>
                }
                @if (moiModel.Id > 0) {
                    @if (targetModule) {
                        <div [attr.name]="'detail.menuDocuments' | t" menuItemId="menuItemDocuments" menuicon="far fa-file" menusystemitem>
                            <document-manager-old
                                [(Documents)]="moiModel.Documents"
                                [permissions]="moiPermissions.documentPermissions"
                                (DocumentsChange)="checkDirty()"
                                [DocumentTypeTargets]="targetModule"
                            >
                            </document-manager-old>
                        </div>
                    }
                    <div
                        [attr.name]="'detail.menuHyperlinks' | t"
                        [attr.menuItemID]="hyperlinksMenuItemId"
                        menuicon="fas fa-external-link-alt"
                        menusystemitem
                    >
                        @if (moiModel.Hyperlinks) {
                            <div>
                                <hyperlink-manager
                                    [Hyperlinks]="moiModel.Hyperlinks"
                                    (HyperlinksChanged)="checkHyperlinksDirty()"
                                    [TargetModule]="targetModule"
                                    [Readonly]="moiPermissions.canOnlyReadMoi"
                                ></hyperlink-manager>
                            </div>
                        } @else {
                            <div>
                                <div class="fancy-loader"></div>
                            </div>
                        }
                    </div>
                }
            </div>
            @if (moiModel.Id > 0) {
                <div [attr.name]="'detail.menuHistory' | t" menuItemId="menuItemHistory" menuicon="fas fa-history" menusystemitem>
                    <app-history-overview [historyDataService]="_moiDS" [Id]="moiModel.Guid">
                    </app-history-overview>
                </div>
            }
        </div>
    </div>
}
